import React from 'react';
import { Box, Container, Heading, Text, Stack, Button, Link } from '@chakra-ui/react';
import { Mail } from 'lucide-react';
import { motion } from 'framer-motion';
const MotionBox = motion(Box);
export function ContactSection() {
  return <Box id="contact" as="section" pt={9} pb={12} bg="gray.50" data-id="element-25">
      <Container maxW="container.md" data-id="element-26">
        <MotionBox initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} data-id="element-27">
          <Stack spacing={6} textAlign="center" align="center" data-id="element-28">
            <Stack spacing={3} data-id="element-29">
              <Heading as="h2" size="xl" data-id="element-30">
                Get in Touch
              </Heading>
              <Text fontSize="lg" color="gray.700" maxW="600px" data-id="element-31">
                Want to chat about AI tools, collaboration, or just say hi? Drop
                me an email.
              </Text>
            </Stack>
            <Button as="a" href="mailto:randula.martin@gmail.com" position="relative" bgGradient="linear(to-r, #1E73BE, #1a5fa0)" color="white" size="lg" leftIcon={<Mail data-id="element-33" />} shadow="md" px={8} overflow="hidden" _before={{
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgGradient: 'linear(to-r, #1a5fa0, #1E73BE)',
            opacity: 0,
            transition: 'opacity 0.6s ease-in-out',
            borderRadius: 'md',
            zIndex: -1
          }} _hover={{
            shadow: 'xl',
            textDecoration: 'none',
            _before: {
              opacity: 1
            }
          }} sx={{
            '& > *': {
              position: 'relative',
              zIndex: 1
            }
          }} data-id="element-32">
              randula.martin@gmail.com
            </Button>
          </Stack>
        </MotionBox>
      </Container>
    </Box>;
}